'use strict';

require('./build/OutsideClickHandler.js');
var OutsideClickHandler = require('../../_virtual/OutsideClickHandler.js_commonjs-exports.js');

// eslint-disable-next-line import/no-unresolved
var reactOutsideClickHandler = OutsideClickHandler.__exports;

module.exports = reactOutsideClickHandler;
